module.exports = __webpack_public_path__ + "static/media/rawpixel-com.8c60b765.jpg";